import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { PublicationsHeader } from './components/PublicationsHeader';
import { ArticleHeader } from './components/ArticleHeader';
import { ArticleHNavList } from './components/ArticleHNavList';
import { ArticleFull } from './components/ArticleFull';
import { ArticleEditor } from './components/ArticleEditor';
import { CollectionHeader } from './components/CollectionHeader';
import { CollectionEditor } from './components/CollectionEditor';
import { Publications } from './components/Publications';
import { Footer } from './components/Footer';
import {
  BrowserRouter as Router,
  Navigate,
  Routes,
  Route,
} from "react-router-dom";

import { getPublications, login } from './api';

function DefaultRouteView() {
  const routeStr = "?route=";
  let q = window.location.search;
  if (q.indexOf(routeStr) === 0) {
    q = q.replace(routeStr, "");
    return (<Navigate to={q} replace />);
  }
  return (<div/>);
}

function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    getPublications(dispatch); // fetch content, login not needed
    setTimeout(() => login(dispatch, "", ""), 100); // attempt to use active session to refresh data (failure is fine)
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/article/:articleID/edit" element={
            <>
              <ArticleHeader />
              <ArticleEditor />
            </>
          } />
          <Route path="/article/:articleID" element={
            <>
              <ArticleHeader />
              <ArticleHNavList />
              <ArticleFull />
            </>
          } />
          <Route path="/collection/:collectionID" element={
            <>
              <CollectionHeader />
              <CollectionEditor />
            </>
          } />
          <Route path="/" element={
            <>
              <DefaultRouteView/>
              <PublicationsHeader />
              <Publications />
              <Footer />
            </>
          } />
        </Routes>
      </Router>
  );
}

export default App;
